import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { UnresponsiveDialogComponent } from './components/unresponsive-dialog/unresponsive-dialog.component';

@NgModule({
  declarations: [ConfirmDialogComponent, UnresponsiveDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports:[ConfirmDialogComponent, UnresponsiveDialogComponent]
})
export class InovaCoreDialogModule { }
